export default "__VITE_ASSET__Cqyv2iqs__"